import { onMounted, computed, ref } from 'vue';
import { API, graphqlOperation } from 'aws-amplify';
import { useRouter } from 'vue-router';

import { awsNow, logintest, AuthGroup } from '@/lib/common';
import { config } from '@/config';

import { listNews, getCompany } from '@/graphql/queries';
import { listTagsWithCourse } from '@/graphql/custom';
import { Tag, User, Company } from '@/@types/d';

export const HeaderComponentSetup = () => {
  const currentUser = ref<User>({});
  const loggedIn = ref(false);

  const router = useRouter();

  const keyword = ref('');
  const modalExpanded = ref(false);

  const company = ref<Company>({});
  const tags = ref([]);
  const newsArrival = ref(false);

  onMounted(() => {
    logintest(initView, clearView, {user:currentUser, state:loggedIn});
  });

  const initView = () => {
    queryListTags();
    queryNews();
    queryCompany();
  };
  const clearView = () => {
    company.value = {};
    tags.value = [];
    keyword.value = '';
  };

  const isCorpAdmin = computed(() => {
    return (currentUser.value && currentUser.value.groups) ? (currentUser.value.groups.includes(AuthGroup.CORPADMIN)): false;
  });

  // 企業取得
  const queryCompany = async () => {
    const cid = currentUser.value.company || '';
    const res: any = await API.graphql(graphqlOperation(getCompany, {id: cid}));
    if(res) {
      company.value = res.data.getCompany;
    }
  };
  const logo = (mode: string) => {
    if(company.value.logos && company.value.logos.length > 0) {
      const r = company.value.logos.find((v:any) => mode === v.device);
      if(r) return r.content;
    } else {
      //@ts-ignore
      return config.LOGO_DEFAULT[mode];
    }
  };
  const logoVisible = computed(() => {
    return !!(company.value.id);
  });
  const logologin = (mode:any) => {
    //@ts-ignore
    return config.LOGO_LOGIN[mode];
  };

  // タグリスト取得 query
  const queryListTags = async () => {
    const params = {
      limit: config.TAGLIST_QUERYLIMIT,
    };
    let res:any;
    try {
      res = await API.graphql(graphqlOperation(listTagsWithCourse, params));
    } catch(err) {
      res = err;
      console.warn(err);
    }
    if(res.data.listTags) {
      tags.value = res.data.listTags.items.filter((t:any) => t.courses.items.filter((c:any) => c).length > 0).sort((a: Tag, b: Tag) => (a.order||0) - (b.order||0));
    }
  };

  // 新着かどうか
  const newsIsNew = (ts: number) => (awsNow() - ts <= config.NEWS_NEW_PERIOD); // 1週間以内の投稿はNew

  // ニュース取得 query
  const queryNews = async () => {
    const n = awsNow();
    const params = {
      filter: {and: {
        displayFrom: {le: n},
        displayTo: {ge: n}
      }},
      limit: config.NEWS_LIST_QUERYLIMIT
    };
    const res: any = await API.graphql(graphqlOperation(listNews, params));
    if(res) {
      if(res.data.listNews.items.length > 0) {
        newsArrival.value = res.data.listNews.items.reduce((pv:any, cv:any) => (pv || newsIsNew(cv.displayFrom)), false);
      }
    }
  };

  // タグリストをフィルタ、ソートし、切り詰めて返す
  const listTagTypes = (type: string, limit: number = tags.value.length): Tag[] => {
    return tags.value
      .filter((tag: Tag) => tag.type === type)
      .slice(0, limit);
  };

  const onSearch = () => {
    if(keyword.value != '') router.push(`/search/${encodeURIComponent(keyword.value)}`);
  };
  
  const openModal = () => {
    // モーダルを表示
    if(modalExpanded.value == false) {
      modalExpanded.value = true;
      // bodyを固定
      const scrollY = window.scrollY;
      document.body.style.position = 'fixed';
      document.body.style.top = -scrollY + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
    }
  };

  const closeModal = () => {
    // console.log(tgModal);
    if(modalExpanded.value == true) {
      // 開くボタンクリック時に設定されたbodyのtopを取得し、bodyの固定を解除
      const scrollY = document.body.style.top;
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      // スクロール位置をモーダルを開いた時と同じ位置に戻す
      window.scrollTo(0, parseInt(scrollY || '0') * -1);

      // ボタンのaria-expanded属性を変更し、対応するモーダルが閉じたと設定する
      // モーダルのaria-hidden属性を変更し、モーダルが閉じたと設定する
      modalExpanded.value = false;
    }
  };

  return {
    loggedIn,
    keyword,
    newsArrival,
    isCorpAdmin,
    logoVisible,
    logo,
    logologin,
    listTagTypes,
    onSearch,
    modalExpanded,
    openModal,
    closeModal
  }
};
